/**
 * WorldMap Plugin
 *
 * @since: 2018-03-19
 * @author: ms1124.kim
 * @version: 0.0.1
 *
 * 수정이력
 *
 * - 2018.03.19 김민수 : 플러그인 정의
 * - 2018.03.23 김민수 : Webpack에서 Remount시 인스턴스 메모리가 전역 컴포넌트에 공유되는 문제 수정
 */

import worldMap from './worldMap.vue'

export default {
  install: function (Vue) {
    const mapInstance = Vue.extend(worldMap)

    // Vue.prototype.$redrawElement = {
    //   line: [],
    //   text: [],
    //   image: [],
    //   circle: [],
    //   tooltip: []
    // }

    Vue.component(worldMap.name, mapInstance)
  }
}
